<template>
  <div id="profit_setting">
    <dd-header
      ref="menuRef"
      :headerType=2
      :isDcPriceDisp="!userInfo.isProfitFlag"
    />
    <div id="content">
      <div id ="main_container">
        <h2 class="title">価格表示設定</h2>
        <section>
          <ul class="profit_list">
            <li>お客様とmm/styleを見ながら商品の選択・カスタマイズができる様に、見積価格の表示有無を設定できる機能です。</li>
            <li>見積価格表示を「あり」に設定すると、卸価格に販売粗利率を反映した価格が商品画面・カート画面に表示されます。</li>
          </ul>
        </section>
        <section>
          <ul class="profit_list">
            <li style="font-weight: bold;">※ 注意事項 ※</li>
            <li>1.カート画面より出力される見積書は、見積価格の表示有無に関わらず<p class="red_text">卸価格が表示</p>されます。</li>
            <li>2.販売粗利率の設定は<p class="red_text">管理者権限を持つユーザーのみ</p>設定可能です。見積価格の表示有無は権限に関わらず設定可能です。</li>
            <li>3.設定した販売粗利率は、<p class="red_text">同じ企業に所属する全ユーザー</p>へ反映されます。</li>
            <li>（管理者権限を持つユーザーは画面左上メニュー内「ユーザー管理」より同企業のユーザーをご確認いただけます）</li>
          </ul>
        </section>
        <section class="form" style="margin-top: 100px">
          <div class="profit_flex">
            <div>販売粗利率</div>
            <div>
              <input class="profit_input" type="text" @blur="blurProfit($event)" v-model="profitParsent" @keypress="validateNumber" @input="profitParsent=convertHalfNumber($event)" oninput="if(value.length>3)value=value.slice(0,3)" :disabled="!isAdmin">%
            </div>
          </div>
        </section>
        <section class="form">
          <div class="profit_content">
            <div class="inline-columns">
              <h2>見積価格表示</h2>
            </div>
            <div class="button01" id="construction">
              <input type="radio" name="construction_radio" id="construction_need" class="radio_need" value=1 v-model.number="profitFlag" />
              <label for="construction_need">あり</label>
              <input type="radio" name="construction_radio" id="construction_no" class="radio_no" checked="" value=0 v-model.number="profitFlag" />
              <label for="construction_no">なし</label>
            </div>
          </div>
        </section>
        <section>
          <ul class="profit_list">
            <li>※ 計算説明</li>
            <li>卸価格が<p style="font-weight: bold;">10,000円</p>（税抜）だった場合、販売粗利率を<p style="font-weight: bold;">{{calcParsent}}%</p>に設定すると</li>
            <li>見積価格 = 10,000円 ÷（1 - {{calcParsent}}%）=&nbsp;<p style="font-weight: bold;">{{formatPrice(profitPrice)}}円</p>（税抜）となり、販売粗利額は<p style="font-weight: bold;">{{formatPrice(grossProfit)}}円</p>（税抜）です。</li>
          </ul>
        </section>
        <section>
          <div class="profit_btn">
            <div v-bind:class="{main_btn: true, update_btn: true}" @click="apply()">
              <a>
                <label>反映する</label>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import {USER_TYPE} from '../constants/TypeEc'
import Header from '../components/common/DcHeader'
import LoadingModal from '../components/common/LoadingModal'
import ToolTip from '../../components/common/ToolTip'
import * as FormUtil from '../../utils/FormUtil'

export default {
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal,
    'tool-tip': ToolTip
  },
  data () {
    return {
      profitParsent: 0,
      profitRate: 0,
      profitFlag: 0,
      userInfo: {},
      imgQmark: this.getImage('common/qmark_gray.svg')
    }
  },
  methods: {
    apply: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          profitRate: this.profitRate,
          profitFlag: this.profitFlag === 1
        }
      }
      let _this = this
      axios.get(DC_URL.TOP + '/profit/white', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$set(_this.userInfo, 'isProfitFlag', (_this.profitFlag === 1))
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, _this.userInfo)
            this.confirmDialog()
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    read: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(DC_URL.TOP + '/profit/read')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.profitRate = response.data.data
            this.profitParsent = (100 - (this.profitRate * 100))
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    blurProfit: function (event) {
      if (event.target.value > 100) {
        this.profitRate = 1
        this.profitParsent = 100
      } else {
        this.profitRate = (100 - this.profitParsent) / 100
      }
    },
    convertHalfNumber: function (event) {
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return ret
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    confirmDialog: function () {
      App.showModal({
        title: '',
        messages: ['反映されました'],
        messageType: 'success',
        layoutType: 'layout-classic',
        modalType: 'confirm',
        textAlign: 'center',
        okBtnLabel: '閉じる',
        cancelBtnLabel: 'TOPへ戻る',
        onOk: () => {
          // 特になし
        },
        onCancel: () => {
          this.$router.push('/mmstyle/top')
        }
      })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  computed: {
    profitPrice: function () {
      if (!this.profitRate) return 10000
      return Math.ceil(10000 / this.profitRate)
    },
    grossProfit: function () {
      if (!this.profitPrice) return 0
      return (this.profitPrice - 10000)
    },
    isAdmin: function () {
      return (this.userInfo.userType === USER_TYPE.DC_ADMIN.code)
    },
    calcParsent: function () {
      return (100 - (this.profitRate * 100))
    }
  },
  mounted: function () {
    this.read()
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.profitFlag = (this.userInfo.isProfitFlag ? 1 : 0)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/dctop2.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#profit_setting {
  background: #FFFFFF;
  height: 100%;
}

#content {
  height: calc(100% - 100px);
  background: #FFFFFF;
  width: 100%;
  padding-top: 100px;
}

.title {
  font-size: 24px;
  width: 800px;
  margin: 40px auto 40px auto;
}

section {
  margin: 20px auto;
  width: 800px;
}

.profit_content {
  margin: 40px 0;
  display: flex;
  div:nth-child(1) {
    line-height: 30px;
    font-size: 18px;
    font-weight: bold;
  }
}

.profit_flex {
  margin: 40px 0;
  display: flex;
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  div:nth-child(2) {
    margin-left: 18px;
  }
}

.profit_btn {
  text-align: left;
  div {
    width: 200px;
    margin-top: 60px;
  }
}

.profit_input {
  width: 30px;
  margin: 0 10px !important;
}

.profit_list {
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  li {
    display: flex;
    margin: 10px 0;
    span {
      width: 200px;
    }
    span:nth-child(2) {
      display: flex;
      margin: 0 20px;
    }
  }
}
.tooltip-parent {
  img {
    vertical-align: top;
  }
}

.red_text {
  font-weight: bold;
  color: #CC0000;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcProfitSetting.vue